import { Tooltip } from "@shopify/polaris"
import React from "react"
import AliexpressLogo from "../../assets/supported-platforms/aliexpress-logo.png"
import CjdropshippingLogo from "../../assets/supported-platforms/cjdropshipping-logo.png"
import EtsyLogo from "../../assets/supported-platforms/etsy-logo.png"
import ShopifyLogo from "../../assets/supported-platforms/shopify-logo.png"
import AmazonLogo from "../../assets/supported-platforms/amazon-logo.webp"
import AlibabaLogo from "../../assets/supported-platforms/alibaba.jpeg"
import SheinLogo from "../../assets/supported-platforms/shein.png"
import TemuLogo from "../../assets/supported-platforms/temu.svg"
import { useTranslation } from "react-i18next"

const SUPPORTED_PLATFORMS = [
	{
		name: "Shopify",
		icon: (
			<img
				src={ShopifyLogo}
				className="supported-platform-icon"
				style={{ height: "1.25rem", width: "1.25rem", opacity: "50%" }}
			/>
		),
		beta: false,
	},
	{
		name: "Aliexpress",
		icon: (
			<img
				src={AliexpressLogo}
				className="supported-platform-icon"
				style={{
					height: "1.25rem",
					width: "1.25rem",
					borderRadius: "0.3125rem",
					opacity: "50%",
				}}
			/>
		),
		beta: false,
	},
	{
		name: "CJDropshipping",
		icon: (
			<img
				src={CjdropshippingLogo}
				className="supported-platform-icon"
				style={{
					height: "1.25rem",
					width: "1.25rem",
					borderRadius: "0.3125rem",
					opacity: "50%",
				}}
			/>
		),
		beta: false,
	},
	{
		name: "Etsy",
		icon: (
			<img
				src={EtsyLogo}
				className="supported-platform-icon"
				style={{
					height: "1.25rem",
					width: "1.25rem",
					borderRadius: "0.3125rem",
					opacity: "50%",
				}}
			/>
		),
		beta: true,
	},
	{
		name: "Amazon",
		icon: (
			<img
				src={AmazonLogo}
				className="supported-platform-icon"
				style={{
					height: "1.25rem",
					width: "1.25rem",
					borderRadius: "0.3125rem",
					opacity: "60%",
					background: "#fff",
				}}
			/>
		),
		beta: true,
	},
	{
		name: "Alibaba",
		icon: (
			<img
				src={AlibabaLogo}
				className="supported-platform-icon"
				style={{
					height: "1.25rem",
					width: "1.25rem",
					borderRadius: "0.3125rem",
					opacity: "60%",
					background: "#fff",
				}}
			/>
		),
		beta: true,
	},
	{
		name: "Shein",
		icon: (
			<img
				src={SheinLogo}
				className="supported-platform-icon"
				style={{
					height: "1.25rem",
					width: "1.25rem",
					borderRadius: "0.3125rem",
					opacity: "60%",
					background: "#fff",
				}}
			/>
		),
		beta: true,
	},
	{
		name: "Temu",
		icon: (
			<img
				src={TemuLogo}
				className="supported-platform-icon"
				style={{
					height: "1.25rem",
					width: "1.25rem",
					borderRadius: "0.3125rem",
					opacity: "60%",
					background: "#fff",
				}}
			/>
		),
		beta: true,
	},
]

export const SupportedPlatformsIcons = () => {
	const { t } = useTranslation()

	return (
		<div style={{ display: "flex", gap: "0.3rem", alignItems: "baseline" }}>
			<span
				style={{
					fontSize: "0.8rem",
					padding: "0.1rem 0.3rem",
					backgroundColor: "#ebebeb",
					color: "#606060",
					borderRadius: "0.3125rem",
				}}
			>
				{t("single.supported_platforms")}
			</span>
			{SUPPORTED_PLATFORMS.map((platform, index) => {
				return (
					<div
						key={index}
						style={{ height: "1.25rem", width: "1.25rem" }}
					>
						<Tooltip
							key={index}
							preferredPosition="top"
							content={
								<div
									style={{
										padding: "0.2rem 0.6rem",
										fontSize: "0.85rem",
									}}
								>
									{platform.name} {platform.beta && "(BETA)"}
								</div>
							}
						>
							{platform.icon}
						</Tooltip>
					</div>
				)
			})}
		</div>
	)
}
